/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30ImplicitOAuthFlow } from './Oas30ImplicitOAuthFlow';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas30PasswordOAuthFlow } from './Oas30PasswordOAuthFlow';
import { Oas30ClientCredentialsOAuthFlow } from './Oas30ClientCredentialsOAuthFlow';
import { Oas30AuthorizationCodeOAuthFlow } from './Oas30AuthorizationCodeOAuthFlow';

/**
 * Models an OpenAPI 3.0.x OAuth Flows.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OAuthFlows
 */
export class Oas30OAuthFlows extends OAuthFlows {
    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitOAuthFlows(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.OAuthFlows#createImplicitOAuthFlow()
     * @return {ImplicitOAuthFlow}
     */
    public createImplicitOAuthFlow() : ImplicitOAuthFlow {
        let rval : Oas30ImplicitOAuthFlow = new Oas30ImplicitOAuthFlow();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.OAuthFlows#createPasswordOAuthFlow()
     * @return {PasswordOAuthFlow}
     */
    public createPasswordOAuthFlow() : PasswordOAuthFlow {
        let rval : Oas30PasswordOAuthFlow = new Oas30PasswordOAuthFlow();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.OAuthFlows#createClientCredentialsOAuthFlow()
     * @return {ClientCredentialsOAuthFlow}
     */
    public createClientCredentialsOAuthFlow() : ClientCredentialsOAuthFlow {
        let rval : Oas30ClientCredentialsOAuthFlow = new Oas30ClientCredentialsOAuthFlow();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.OAuthFlows#createAuthorizationCodeOAuthFlow()
     * @return {AuthorizationCodeOAuthFlow}
     */
    public createAuthorizationCodeOAuthFlow() : AuthorizationCodeOAuthFlow {
        let rval : Oas30AuthorizationCodeOAuthFlow = new Oas30AuthorizationCodeOAuthFlow();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    constructor() {
        super();
    }
}
Oas30OAuthFlows["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30OAuthFlows";
Oas30OAuthFlows["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




